import React, { useEffect } from "react";
import OrbitingIcons from "../OrbitingIcons/OrbitingIcons";
import { useAppConfig } from "../../../appConfig";
import "./TenantLoginPage.scss";

const DEFAULT_SPLASH_GRADIENT =
  "linear-gradient(135deg, #060d1a 0%, #0a1628 50%, #0f1f3a 100%)";

const TenantLoginPage = () => {
  const { tenant } = useAppConfig() || {};
  const themeVars = tenant?.themeVars || {};
  const splashGradient =
    themeVars["--splash-gradient"] || DEFAULT_SPLASH_GRADIENT;
  const accentColor = themeVars["--tenant-accent-color"] || "#93c5fd";
  const logoSrc = tenant?.assets?.logos?.logoWhite || "";

  useEffect(() => {
    if (tenant?.head?.title) document.title = tenant.head.title;
  }, [tenant?.head?.title]);

  const continueWithMls = () => {
    if (tenant?.ssoProvider) {
      const baseAPIURL = process.env.REACT_APP_API_BASE_URL;
      if (tenant.ssoType === "saml") {
        return (window.location.href = `${baseAPIURL}api/v2/auth/saml/${tenant.ssoProvider}/login`);
      }
      if (tenant.ssoType === "oicd") {
        return (window.location.href = `${baseAPIURL}api/v2/auth/oauth/${tenant.ssoProvider}/authorize`);
      }
    }
  };

  return (
    <section
      className="tenant-login"
      style={{ "--tenant-accent-color": accentColor }}
    >
      <div
        className="tenant-login__visual"
        style={{ background: splashGradient }}
      >
        {logoSrc && (
          <img className="tenant-login__logo" src={logoSrc} alt="Logo" />
        )}
        <OrbitingIcons />
        <span
          className="tenant-login__anchor"
          style={{
            background: accentColor,
            boxShadow: `0 0 24px 8px ${accentColor}33`,
          }}
        />
      </div>

      <div className="tenant-login__panel">
        {logoSrc && (
          <img
            className="tenant-login__logo tenant-login__logo--mobile"
            src={logoSrc}
            alt="Logo"
          />
        )}

        <div className="tenant-login__card">
          <h1 className="tenant-login__title">Welcome back</h1>
          <p className="tenant-login__subtitle">
            Sign in to access real-time buyer demand data for your market.
          </p>

          <div className="tenant-login__choices">
            <button
              type="button"
              className="btn btn-primary tenant-login__sso"
              onClick={continueWithMls}
            >
              <span className="tenant-login__sso-label">Continue with MLS</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TenantLoginPage;
